import { render, staticRenderFns } from "./RemortgageReviewPage.vue?vue&type=template&id=336fb836&scoped=true&"
import script from "./RemortgageReviewPage.vue?vue&type=script&lang=js&"
export * from "./RemortgageReviewPage.vue?vue&type=script&lang=js&"
import style0 from "./RemortgageReviewPage.vue?vue&type=style&index=0&id=336fb836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336fb836",
  null
  
)

export default component.exports